import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";

export function CTAFinal() {
  return (
    <div style={{ background: "var(--dark)", position: "relative", overflow: "hidden" }}>
      <div style={{
        position: "absolute", left: "50%", top: -40, transform: "translateX(-50%)",
        width: 280, height: 280, background: "radial-gradient(circle, var(--sage), transparent 70%)", opacity: 0.28,
      }} />
      <div className="container" style={{ position: "relative", paddingTop: 72, paddingBottom: 24, textAlign: "center" }}>
        <Reveal>
          <img src="/logo-psicodosis.png" alt="" style={{ width: 64, height: 64, objectFit: "contain", margin: "0 auto 20px" }} />
          <h2 className="fluid-heading-md" style={{ fontFamily: "var(--font-display)", fontWeight: 800, letterSpacing: "-0.02em", margin: "0 0 12px", color: "var(--on-dark)" }}>
            Empieza donde estás hoy
          </h2>
          <p style={{ fontSize: 18, color: "var(--on-dark-muted)", margin: "0 0 28px" }}>
            Gratis, sin presión, y nunca en soledad.
          </p>
          <Link to="/registro" className="btn btn-dark btn--lg">Únete a PzicoDosis</Link>
        </Reveal>
      </div>
    </div>
  );
}
